import { INVESTMENT_PROFILE_TYPE_JOINT } from "@components/Domain"


const isJointInvestment = ({ profileType }) => {
  return profileType === INVESTMENT_PROFILE_TYPE_JOINT
}

export default isJointInvestment
